// 用户-角色的api
import request from '@/utils/request'

// 获取 用户-角色列表
export function getUserRole(data) {
  return request({
    url: '/admin/setting/webUserRole/list',
    method: 'post',
    data
  })
}
// 添加 用户-角色
export function addUserRole(data) {
  return request({
    url: '/admin/setting/webUserRole/add',
    method: 'post',
    data: data
  })
}
// 更新 用户-角色
export function updateUserRole(data) {
  return request({
    url: '/admin/setting/webUserRole/edit',
    method: 'post',
    data: data
  })
}
